import { render, staticRenderFns } from "./mainSuccessStories.vue?vue&type=template&id=b57cd624&scoped=true&"
import script from "./mainSuccessStories.vue?vue&type=script&lang=js&"
export * from "./mainSuccessStories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57cd624",
  null
  
)

export default component.exports